import React, { useMemo } from 'react';
import moment from 'moment';
import { TuneRounded } from '@mui/icons-material';
import { REQUEST_STATUS } from '@src/constants/voice';
import { AUDIO_EFFECTS_URL } from '@src/configs';

import { StyledIconButton } from './index.styled';

const AudioEffect = ({ request = {} }) => {
  const isDisable = useMemo(() => {
    const { retentionPeriod, createdAt, status } = request;
    const isSuccessRequest = status === REQUEST_STATUS.SUCCESS;
    const audioExpired = moment().isAfter(
      moment(createdAt).add(retentionPeriod, 'days'),
    );

    if (isSuccessRequest && !audioExpired) return false;
    return true;
  }, [request]);

  const handleAudioEffect = () => {
    const { audioLink } = request;
    window.open(`${AUDIO_EFFECTS_URL}/?audio=${audioLink}`, '_blank');
  };

  return (
    <>
      <StyledIconButton
        disabled={isDisable}
        height="40px"
        width="40px"
        padding="12px"
        onClick={handleAudioEffect}
      >
        <TuneRounded style={{ fontSize: '24px' }} className="icon" />
      </StyledIconButton>
    </>
  );
};

export default AudioEffect;
